module.exports = __webpack_public_path__ + "3cce4f12d5ecf8cc090fc786657ca848.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/detsky-tabor-1-5.jpg
// module id = 1215
// module chunks = 0